import { getCalibrationKindLabels } from '../../helpers/getCalibrationKindLabels';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { CALIBRATION_KINDS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CalibrationKindSelector: FunctionComponent<Props> = ({
    className = '',
    onSelect,
    selectedKind,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const calibrationKindLabels = getCalibrationKindLabels(t);

    return (
        <VerticalContainer
            className={`${styles.calibrationKindSelector} ${className}`}
            testId={testId}>
            <Wrapper className={styles.label}>{t.LOG_SERVICE_CALIBRATION_KIND}</Wrapper>

            <VerticalContainer className={styles.menu}>
                {CALIBRATION_KINDS.map(calibrationKind => {
                    const selectedClass = calibrationKind === selectedKind ? styles.isSelected : '';

                    return (
                        <Wrapper
                            className={`${styles.menuRow} ${selectedClass}`}
                            key={calibrationKind}
                            onClick={() => onSelect({ calibrationKind })}
                            testId={`${testId}-${calibrationKind}`}>
                            {calibrationKindLabels[calibrationKind]}
                        </Wrapper>
                    );
                })}
            </VerticalContainer>
        </VerticalContainer>
    );
};

export default CalibrationKindSelector;
